export function parseKrtForExpression(raw) {
    const [, left, right] = raw.match(/^\s*([A-Za-z]\w*)\s+in\s+(data\.[A-Za-z]\w+)\s*$/) ?? [];
    return left && right ? { left, right } : null;
}
export function renderKrtForExpression({ left, right }) {
    return `${left} in ${right}`;
}
